"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withModal = exports.ModalWrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.ModalWrapper = styled_components_1.default.div `
   position: relative;
   width: 300px;
   max-height: 500px;
   overflow: hidden;
   top: calc((100vh - 500px - 21px) / 3);
   bottom: calc(2 * (100vh - 500px - 21px) / 3);

   background: #ffffff;

   @media only screen and (max-height: 520px) {
      position: static;
      top: auto;
   }

   border-radius: 5px;
   border: 0;

   -moz-box-shadow: 0 0 10px #000;
   -webkit-box-shadow: 0 0 10px #000;
   box-shadow: 0 0 10px #000;
`;
exports.withModal = (Component) => {
    return (props) => (react_1.default.createElement(exports.ModalWrapper, null,
        react_1.default.createElement(Component, Object.assign({}, props))));
};
//# sourceMappingURL=ModalWrapper.js.map